<template>
  <div class="app-container">
    <div class="back-list" @click="back"><<返回</div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入材料名称"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table style="width: 100%" v-loading="loading" :data="listingDetailList" @selection-change="handleSelectionChange">
<!--      <el-table-column type="selection" width="55" align="center" />-->
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="ID">
              <span>{{ props.row.id }}</span>
            </el-form-item>
            <el-form-item label="材料名称">
              <span>{{ props.row.name }}</span>
            </el-form-item>
            <el-form-item label="参数规格">
              <span>{{ props.row.spec }}</span>
            </el-form-item>
            <el-form-item label="单位">
              <span>{{ props.row.unit }}</span>
            </el-form-item>
            <el-form-item label="数量">
              <span>{{ props.row.amount }}</span>
            </el-form-item>
            <el-form-item label="含税单价(元)">
              <span>{{ props.row.unitPrice }}</span>
<!--              <el-input-->
<!--                v-if="!props.row.quoteDetailId"-->
<!--                type="number"-->
<!--                v-model="unitPrice"-->
<!--                placeholder="请输入含税单价"-->
<!--                size="small"-->
<!--              />-->
            </el-form-item>
            <el-form-item label="税率(%)">
              <span>{{ props.row.tax }}</span>
<!--              <el-input-->
<!--                v-if="!props.row.quoteDetailId"-->
<!--                type="number"-->
<!--                v-model="tax"-->
<!--                placeholder="请输入税率"-->
<!--                size="small"-->
<!--              />-->
            </el-form-item>
            <el-form-item label="含税总价(元)">
              <span>{{ props.row.totalPrice }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{ props.row.remark }}</span>
            </el-form-item>
<!--            <el-form-item label="">-->
<!--              <el-button type="primary" icon="" size="mini" @click="save(props.row)" v-if="!props.row.quoteDetailId">提交报价</el-button>-->
<!--            </el-form-item>-->
          </el-form>
        </template>
      </el-table-column>
<!--      <el-table-column label="ID" align="center" prop="id" />-->
      <el-table-column label="材料名称" align="center" prop="name" />
<!--      <el-table-column label="参数规格" align="center" prop="spec" />-->
<!--      <el-table-column label="单位" align="center" prop="unit" />-->
<!--      <el-table-column label="数量" align="center" prop="amount" />-->
<!--      <el-table-column label="控制含税单价(元)" align="center" prop="unitPrice" />-->
      <el-table-column width="150" label="含税单价(元)" align="center" prop="unitPrice">
        <template slot-scope="scope">
          <el-input-number controls-position="right" :min="0" size="small" v-model="scope.row.unitPrice" placeholder="请输入" :disabled="!canUpload || scope.row.quoteDetailId"/>
        </template>
      </el-table-column>
      <el-table-column width="150" label="税率(%)" align="center" prop="tax">
        <template slot-scope="scope">
          <el-input-number controls-position="right" :min="0" size="small" v-model="scope.row.tax" placeholder="请输入" :disabled="!canUpload || scope.row.quoteDetailId"/>
        </template>
      </el-table-column>
<!--      <el-table-column label="税率(%)" align="center" prop="tax" />-->
<!--      <el-table-column label="控制含税总价(元)" align="center" prop="totalPrice" />-->
<!--      <el-table-column label="备注" align="center" prop="remark" />-->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            v-if="canUpload && !scope.row.quoteDetailId"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="save(scope.row)"
          >提交</el-button>
        </template>
      </el-table-column>
    </el-table>
<!--    <pagination-->
<!--      v-show="total>0"-->
<!--      :total="total"-->
<!--      :page.sync="queryParams.pageNum"-->
<!--      :limit.sync="queryParams.pageSize"-->
<!--      @pagination="getList"-->
<!--    />-->
  </div>
</template>

<script>
import { listListingDetail, getListingDetail, delListingDetail, addListingDetail, updateListingDetail } from "@/api/purchase/enquiryListingDetail";
import { addQuoteListingDetail } from "@/api/purchase/quoteListingDetail";
import UploadImport from "@/components/UploadImport/index";
import { getUserInfo, register } from "@/api/user";
export default {
  name: "EnquiryListingDetail",
  components: {
    UploadImport,
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 清单信息表格数据
      listingDetailList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        unit: null,
        spec: null,
        unitPrice: null,
        uuid: null,
        version: null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },
      // 导入数据
      importData: {
        title: "",
        open: false,
        // 上传的地址
        url:
          process.env.VUE_APP_BASE_API + "/purchase/enquiryListingDetail/importData",
        // 模板文件信息
        templateFile: {
          fileName: "询价清单导入模板文件",
          filePath: "/assets/template/purchase/询价清单导入模板文件.xlsx",
        },
      },
      listingOpen: false,
      listingInfoList: [],
      isView: false,
      canUpload: false,
    };
  },
  created() {
    this.queryParams.applyId = this.$route.query["id"];
    let canUploadStr = this.$route.query["canUpload"];
    if(canUploadStr === true || canUploadStr === 'true'){
      this.canUpload = true;
    }else {
      this.canUpload = false;
    }
    getUserInfo().then(response => {
      this.userInfo = response.data;
      this.queryParams.idCard = this.userInfo.user.idCard;
      this.getList();
    });
  },
  props:{
    approveRecordOpenFunc3: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    approveRecordOpenFunc3(val) {
      this.listingOpen = val;
    }
  },
  methods: {
    save(row) {
      if(!row.unitPrice || !row.tax){
        this.$message.error("含税单价或税率不能为空！");
        return;
      }
      getUserInfo().then(response => {
        this.userInfo = response.data;
        addQuoteListingDetail({
          applyId: row.id,
          idCard: this.userInfo.user.idCard,
          unitPrice: row.unitPrice,
          totalPrice: row.amount*row.unitPrice,
          tax: row.tax,
        }).then(response => {
          this.$message.success("提交成功！");
          this.getList();
        });
      }).catch(err => {
        return Promise.reject(err);
      });
    },
    back() {
      // this.open = false;
      this.$router.back();
      this.reset();
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if ('控制含税总价(元)' == column.label) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    /** 查询清单信息列表 */
    getList() {
      this.loading = true;
      listListingDetail(this.queryParams).then(response => {
        this.listingDetailList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        unit: null,
        spec: null,
        unitPrice: null,
        remark: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        createBy: null,
        uuid: null,
        version: null,
        amount: null,
        totalPrice: null,
        tax: null,
        applyId: null,
        listingInfoId: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('purchase/enquiryListingDetail/export', {
        ...this.queryParams
      }, `询价清单.xlsx`)
    },
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 120px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}

.back-list{
  height: 100px;
  line-height: 100px;
  color: blue;
  cursor: pointer;
}
</style>
